import React, { SVGProps } from "react";
import Icon from "./Icon/Icon";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIcon = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M15.53 2.266a.472.472 0 0 0-.5.5v1.3a2.1 2.1 0 0 0-.4-.6 7.7 7.7 0 0 0-2.2-2.2 6 6 0 0 0-1.4-.7 9 9 0 0 0-1.5-.5 10.9 10.9 0 0 0-3.1.1 9 9 0 0 0-1.5.5 6.8 6.8 0 0 0-1.4.7 7 7 0 0 0-2.1 2.1 10 10 0 0 0-.8 1.4 9 9 0 0 0-.5 1.5 8.7 8.7 0 0 0-.13 1.6 17 17 0 0 0 .126 1.722 4.7 4.7 0 0 0 .4 1.378 5.8 5.8 0 0 0 .7 1.4 7.7 7.7 0 0 0 2.2 2.2 9 9 0 0 0 1.4.7 9 9 0 0 0 1.5.5 8.6 8.6 0 0 0 3.2 0 9 9 0 0 0 1.5-.5 6 6 0 0 0 1.4-.7 9 9 0 0 0 2.211-2.181 5 5 0 0 0 .389-.619.61.61 0 0 0-.1-.786c-.23-.178-.54-.239-.7-.014-.2.3-.3.5-.5.8a5.75 5.75 0 0 1-1.9 1.9l-1.2.6a6.5 6.5 0 0 1-1.3.4 6.6 6.6 0 0 1-2.8 0 8 8 0 0 1-1.311-.381 4.2 4.2 0 0 1-1.187-.619 5.75 5.75 0 0 1-1.9-1.9c-.2-.4-.267-.489-.6-1.2a7.4 7.4 0 0 1-.4-1.3 6.5 6.5 0 0 1-.1-1.4 6 6 0 0 1 .1-1.4 6.5 6.5 0 0 1 .4-1.3 7.5 7.5 0 0 1 .7-1.2 5.76 5.76 0 0 1 1.881-1.922 5 5 0 0 1 1.196-.636 9 9 0 0 1 1.325-.34 6.6 6.6 0 0 1 2.8 0 6.5 6.5 0 0 1 1.3.4l1.2.6a5.75 5.75 0 0 1 1.9 1.9c.2.3.3.5.5.8l-1.4-.6c-.3-.1-.5 0-.7.3-.1.3 0 .5.3.7l2.3 1a1.1 1.1 0 0 0 .489.111.74.74 0 0 0 .56-.321 1.5 1.5 0 0 0 .136-.688l.015-2.6a.472.472 0 0 0-.5-.504" />
  </svg>
);
const SvgArrowRefresh = (
  props: Omit<React.ComponentProps<typeof Icon>, "SvgIcon" | "name">
) => <Icon SvgIcon={SvgIcon} name="arrow-refresh" {...props} />;
export default SvgArrowRefresh;
